// extracted by mini-css-extract-plugin
export default {"col_w1000":"index_col_w1000_w9ggN","listTeam":"index_listTeam_Ur4Bd","pic":"index_pic_vwbJZ","txt":"index_txt_huQ3Z","space26":"index_space26_aozfe"};